angular.module('filters').filter('dayOfMonth', function() {
  return function(input) {
    if (input) {
      return moment(input, 'YYYY-MM-DD').format('D MMMM');
    }
  };
});
